import {Controller} from "@mecatran-components/controller"
import {OriginDestination} from "@mecatran-components/origindestination";
import {Input} from "@mecatran-components/input";
import {BackButton} from "../components/backbutton.component.mjs";
import {SuggestionList, SuggestionListOptions} from "../components/suggestionlist.component.mjs";
import * as sources from "SRC/services/datasources/factorysources.mjs";
import {PlanRoute} from "../services/planroute.service.mjs";

/**
 * destination - Stop [mandatory]
 * view - Component [mandatory]
 */
export class DestineoPlanner extends Controller{
    constructor(view, destination){
        if (!(view && destination)) throw new Error('Destineo Planner. Parameters are mandatory')
        var destineoPlannerOptions = destineoPlannerOptions || {};
        super(view);
        var _destination = destination;
        var isSchool = destination.getIsSchool(); 
        var _type = (isSchool) ? 'school' : 'home'; 
        var _layout; 

        /* ======================================= */
        /* PUBLIC                                  */
        /* ======================================= */

        Object.defineProperty(this,'type',{
            get : function(){ return _type }
        })

        Object.defineProperty(this,'destination',{
            get : function(){ return _destination }
        });

        Object.defineProperty(this,'layout',{
            set : function(d){ _layout = d },
            get : function(){ return _layout }
        })

        /* ======================================= */
        /* PRIVATE                                 */
        /* ======================================= */

        this.initDestineoPlanner(destination, destineoPlannerOptions);
    }

    // ==========
    // private 
    // ----------
    getView(){ return this.view }

    setView(v){ this.view = v }


    getOriginDestinationData(){
        var ret = {}
        var banData = this.dataStore.get('ban');
        var stopData = this.dataStore.get('stop');
        var odTag1 = this.odTagManager.getODTag('ban');
        var odTag2 = this.odTagManager.getODTag('stop');
        ret[odTag1] = banData;
        ret[odTag2] = stopData;
        return ret; 
    }

 

    getNameStr(stop){
        if (!stop) return;
        var name = stop.name;
        var city = stop.city;
        return `${name} ${city}`
    }

    isDestineoLaunch(element){
        var id = element.id;
        console.log('destineo launch id',id);
        return (id === 'destineo-launch');
    }

    isInput(element){
        console.log('clicked element', element)
        return true;
    }

    isOriginDestination(element){
        return element.classList.contains('origin-destination');
    }

    closeAllLists(){
        this.removeFromView(this.banSuggestionListName);
    }

    buildPlanRoute(data){
        var site = 'pdl'; // TO relocate 
        var planRoute = new PlanRoute(site);
        var origin = data.origin;
        var destination = data.destination; 
        planRoute.from = this.getNameStr(origin);
        planRoute.to = this.getNameStr(destination);
        planRoute.fromLat = origin.lat;
        planRoute.fromLon = origin.lon;
        planRoute.toLat = destination.lat;
        planRoute.toLon = destination.lon;
        planRoute.date = "2021-05-30";
        planRoute.time = "16:20";
        planRoute.deparr = "dep";
        planRoute.wheelchairAccess = false;
        planRoute.plan(); 
    }

    /*
    appendLayoutToView(){
        this.layout = this.createLayout();
        var viewNode = this.view.getDomNode();
        var selector = "#lateral-panel-bloc";
        var contentNode = viewNode.querySelector(selector);
        contentNode.appendChild(this.layout);
    }

    removeLayoutFromView(){
        this.layout.remove();
    }
    */

    leaveView(){
        this.removeFromView(this.backButtonName);
        this.removeFromView(this.odName);
        this.removeFromView(this.destineoLaunchName);
        this.removeFromView(this.banSuggestionListName);
    }

    
    createBackButton(){
        return new BackButton();
    }


    /**
     * 
     * @param origin type Stop 
     * @param destination type Stop 
     * @returns 
     */
    createOriginDestination(){
        var inputOptions = { placeholder : 'tapez une adresse de départ ' }
        var origin = { inputOptions }
        var odOptions = { origin }
        var od = new OriginDestination(odOptions);

        //od.setDestinationValue(this.getNameStr(destination));
        return od;
    }


    createBanSuggestionList(stop){
        var banSource = sources.banSource;
        if (stop && stop.lat && stop.lon) banSource.setCenter([stop.lat,stop.lon]);
        // banSource.setQuery(stop.name);
        var suggestionListOptions = new SuggestionListOptions(banSource);
        var banSuggestionList = new SuggestionList(suggestionListOptions);
        banSuggestionList.build();
        return banSuggestionList;

    }

    createDestineoLaunch(){
        var options = { 
            id : 'destineo-launch',
            type : 'image',
            value : 'cherchez sur Destineo',
            src : './assets/destineo.png'
        }
        var launchButton = new Input(options);
        return launchButton;
    }

    createLayout(){
        var container = this.createElement('div','destineo-planner',['destineo-planner']);
        var backButton = this.createElement('div','back-button');
        var od = this.createElement('div','origin-destination');
        var span = this.createElement('span','message');
        span.innerText = "Recherchez votre itinéraire avec"
        var launch = this.createElement('div','launch',[]);
        var banSuggestionList = this.createElement('div','suggestionlist');
        container.appendChild(backButton);
        container.appendChild(od);
        container.appendChild(span);
        container.appendChild(launch);
        container.appendChild(banSuggestionList)
        return container;
    }

    createElement(type, id,classList= []){
        var el = document.createElement(type);
        el.setAttribute('id',id);
        classList.forEach(klass => el.classList.add(klass));
        return el; 
    }


    createViewListener(){
        var viewNode = this.view.getDomNode();
        viewNode.addEventListener('click',(event)=>{
            this.closeAllLists();
        });
    }

    registerBackButton(){
        var name = 'backbutton';
        this.backButtonName = name;
        this.register(name, this.createBackButton);
        this.registerEventDefineListener(name,['backEvent',()=>true,this.onBackEvent.bind(this)]);
        this.createComponent(name);
    }

    registerOriginDestination(){
        var name = 'origindestination';
        //this.setODName(name);
        this.odName = name;
        this.register(name,this.createOriginDestination)
        this.registerEventDefineListener(name,['clickEvent',()=>true,this.onOriginDestinationClickEvent.bind(this)]);
        this.registerEventDefineListener(name,['inputEvent',this.isInput,this.onOriginDestinationInputEvent.bind(this)]);
        this.registerEventDefineListener(name,['click',this.isOriginDestination, this.onOriginDestinationClick.bind(this)])
        this.createComponent(this.odName);
    }

    registerBanSuggestionList(stop){
        var name = 'bansuggestionlist';
        this.banSuggestionListName = name;
        this.register(name,this.createBanSuggestionList)
        this.registerEventDefineListener(name,['selectEvent',()=>true,this.onBanSuggestionListSelectEvent.bind(this)]);   
        this.createComponent(this.banSuggestionListName, stop);     
    }

    registerDestineoLaunch(){
        var name = 'destineolaunch';
        this.destineoLaunchName = name;
        this.register(name,this.createDestineoLaunch);
        this.registerEventDefineListener(name,['click',this.isDestineoLaunch,this.onDestineoLaunch.bind(this)]);
        this.createComponent(name);
    }

    notifyBackEvent(){
        var stop = this.destination;
        var type = this.type;
        var controllerManager = this.controllerManager;
        if (controllerManager) controllerManager.onBackButton(this,type, stop);// Improve use events or a callback to avoid this dependency     
    }

    onBackEvent(event){
        this.leaveView();
        this.notifyBackEvent();
    }

    onDestineoLaunch(){
        var data = this.getOriginDestinationData();
        console.log('data',data)
        this.buildPlanRoute(data);
    }

    onOriginDestinationClickEvent(event){
        var id = event.detail; 
        this.closeAllLists();
        console.log('OD Click Event')
        switch(id){
            case 'reverse':
                return this.onOriginDestinationReverse(event);
            case 'clear-destination':
            case 'clear-origin':
                return this.onOriginDestinationClear(event);
        }
        var customTag = this.odTagManager.getCustomTag(id);
        switch(customTag){
            case 'stop':
                this.closeAllLists();
                return; 
                break;
            case 'ban':
                this.addToView(this.banSuggestionListName, this.bodyPanelSelector)
                break;
        }
    }

    onOriginDestinationClick(event){
        console.log('OD Click')
        this.closeAllLists();
    }

    onOriginDestinationClear(event){
        var id = event.detail;
        switch(id){
            case 'clear-destination':
                var customTag = this.odTagManager.getCustomTag('destination');
                break;
            case 'clear-origin':
                var customTag = this.odTagManager.getCustomTag('origin')
                break;
        }
        if (customTag === 'ban') sources.banSource.setQuery(''); // to remove 
        this.dataStore.clear(customTag);
    }

    onOriginDestinationReverse(event){
        this.odTagManager.swapTags();
    }

    onOriginDestinationInputEvent(event){
        console.log('input origin destination', Event)
        var query = event.detail.query; 
        var banSuggestionList = this.createComponent(this.banSuggestionListName);
        var banSource = banSuggestionList.getDataSource();
        banSource.setQuery(query)
        this.addToView(this.banSuggestionListName, this.bodyPanelSelector); 
    }

    onBanSuggestionListSelectEvent(event){
        console.log('ban suggestion list select event',event)
        var data = event.detail.data; 
        this.removeFromView(this.banSuggestionListName)
        this.addToView(this.destineoLaunchName, this.headerPanelSelector)
        this.dataStore.save('ban',data);
        this.odTagManager.setValue('ban',this.getNameStr(data))
    }

    initDestineoPlanner(destination){
        // destination should be of type Stop (to verify or throw an error)
        this.headerPanelSelector = "#header-panel"; 
        this.bodyPanelSelector = "#body-panel"
        this.footerPanelSelector =  "#footer-panel"; 

    
       /*
        this.view.setHeight(this.headerPanelSelector, '20vh');
        this.view.setTopPosition(this.bodyPanelSelector, '20vh' )
        */
        this.view.show(this.bodyPanelSelector);


        this.createViewListener();

        this.registerBackButton();
        this.registerOriginDestination();   
        this.registerBanSuggestionList(destination);    
        this.registerDestineoLaunch();
        this.addToView(this.backButtonName, this.headerPanelSelector);
        this.addToView(this.odName, this.headerPanelSelector );  
        this.addToView(this.destineoLaunchName, this.headerPanelSelector );  
        
        var odTagManager = new ODTagManager('ban','stop',this.getComponent(this.odName));
        this.odTagManager = odTagManager;

        var dataStore = new DataStore();
        this.dataStore = dataStore; 

        odTagManager.setValue('stop',this.getNameStr(destination));
        dataStore.save('stop',destination);

    }
}

/**
 * destineoPlannerOptions interface
 * --------------------------------
 * view - Component 
 */


/**
 * allows to set and get a tag name on the origin / destination fields (check onOriginDestinationClick)
 * customTag1 - string associated with the initial  origin content 
 * customTag2 - string associated with the initial dest content 
 * od - OriginDestination component
 * 
 * customTags VS odTags (odTags are 'origin' or 'destination')
 */
class ODTagManager{
    constructor(customTag1, customTag2, od){
        this.origin = customTag1;
        this.destination = customTag2;
        this.od = od; 
    }
    // ============
    // private 
    // ------------

    
    swapTags(){
        var or = this.origin;
        this.origin = this.destination;
        this.destination = or; 
    } 
    
    setValue(customTag,value){
        this.od.setValue(this.getODTag(customTag),value);
    }
    getValue(customTag){
        return this.od.getValue(this.getODTag(customTag));
    }

    getODTag(customTag){
        var tags = { 'origin' : this.origin, 'destination' : this.destination }
        var ret = {}
        for (var [key,value] of Object.entries(tags)){ ret[value] = key }
        return ret[customTag]; // 'origin' or 'destination'
    }

    getCustomTag(odTag){
        switch(odTag){
            case 'origin':
                return this.origin;
                break;
            case 'destination':
                return this.destination;
                break;
        }
    }

}



/*
Save the selected data  
*/

class DataStore{
    constructor(){
        var _dataMap = new Map([]);

        this.dataMap = _dataMap;
    }
    save( customTag, data){
        this.dataMap.set(customTag,data) 
    }

    get(customTag){
        return this.dataMap.get(customTag)
    }

    clear(customTag){
        this.dataMap.set(customTag,undefined)
    }
}